import React from 'react';
import PropTypes from 'prop-types';
// import { apiClient } from '../../../services/apiClient';

// const PaymentSummary = ({ totals, tax }) => (
// const PaymentSummary = ({ totals, applyCoupon, hasProducts = false, resetCoupon }) => {
  const PaymentSummary = ({ totals }) => {
  // const [couponCode, setCouponCode] = useState('');
  // const [couponLoading, setCouponLoading] = useState(false);
  // const [couponError, setCouponError] = useState('');
  // const [discountValue, setDiscountValue] = useState(0);

  // const handleCouponChange = (e) => {
  //   setCouponCode(e.target.value);
  //   setCouponError('');
  // };

  // useEffect(() => {
  //   if (resetCoupon) {
  //     setCouponCode('');
  //     setDiscountValue(0);
  //     setCouponError('');
  //   }
  // }, [resetCoupon]);

  // const handleApplyCoupon = async () => {
  //   if (!couponCode.trim()) {
  //     return;
  //   }

  //   setCouponLoading(true);
  //   setCouponError('');
  //   setDiscountValue(0);

  //   try {
  //     const response = await apiClient.post('/coupon-validate', { code: couponCode });
      
  //     if (response.success) {
  //       // Pass the coupon ID along with other coupon data
  //       const couponData = {
  //         ...response.coupon,
  //         id: response.coupon.id // Ensure the ID is included
  //       };
  //       applyCoupon(couponData);
  //       setCouponError('');
  //       if (response.discount_value) {
  //         setDiscountValue(parseFloat(response.discount_value));
  //       }
  //     } else {
  //       setCouponError(response.message || 'Invalid coupon code');
  //     }
  //   } catch (error) {
  //     console.error('Failed to validate coupon:', error);
  //     setCouponError('Failed to validate coupon. Please try again.');
  //   } finally {
  //     setCouponLoading(false);
  //   }
  // };

  return (
  <div className="order-total bg-total bg-white p-0">
    <h5 className="mb-3">Payment Summary</h5>
    <table className="table table-responsive table-borderless">
      <tbody>
        {/* <tr>
          <td>
            Tax
            <a href="#" className="ms-3 link-default" data-bs-toggle="modal" data-bs-target="#order-tax">
              <i className="ti ti-edit"></i>
            </a>
          </td>
          <td className="text-gray-9 text-end">${tax.toFixed(2)}</td>
        </tr> */}
        <tr>
          <td>
            <span className="text-danger">Discount</span>
            <a href="#" className="ms-3 link-default" data-bs-toggle="modal" data-bs-target="#discount">
              <i className="ti ti-edit"></i>
            </a>
          </td>
          <td className="text-danger text-end">PKR {totals.totalDiscount.toFixed(2)}</td>
        </tr>
        <tr>
          <td>Sub Total</td>
          <td className="text-gray-9 text-end">PKR {totals.subtotal.toFixed(2)}</td>
        </tr>
        {/* {hasProducts && (
          <tr className="border-top border-dashed">
            <td colSpan="2">
              <div className="input-group mb-2 mt-3">
                <input 
                  type="text" 
                  className="form-control" 
                  placeholder="Enter coupon code" 
                  value={couponCode} 
                  onChange={handleCouponChange}
                  disabled={couponLoading}
                />
                <button 
                  className="btn btn-primary" 
                  type="button" 
                  onClick={handleApplyCoupon}
                  disabled={couponLoading}
                >
                  {couponLoading ? 'Applying...' : 'Apply'}
                </button>
              </div>
              {couponError && <div className="text-danger small mb-2">{couponError}</div>}
              {discountValue > 0 && <div className="text-success small mb-2">Discount: PKR {discountValue.toFixed(2)}</div>}
            </td>
          </tr>
        )}
        {totals.couponDiscount > 0 && (
          <tr>
            <td><span className="text-success">Coupon Discount</span></td>
            <td className="text-success text-end">PKR {totals.couponDiscount.toFixed(2)}</td>
          </tr>
        )} */}
        <tr>
          <td className="fw-bold border-top border-dashed">Total Payable</td>
          {/* <td className="text-gray-9 fw-bold text-end border-top border-dashed">PKR {(parseFloat(totals.total) - parseFloat(discountValue || 0)).toFixed(2)}</td> */}
          <td className="text-gray-9 fw-bold text-end border-top border-dashed">PKR {(parseFloat(totals.total))}</td>
        </tr>
      </tbody>
    </table>
  </div>
  );
};

PaymentSummary.propTypes = {
  totals: PropTypes.shape({
    subtotal: PropTypes.number.isRequired,
    totalDiscount: PropTypes.number.isRequired,
    total: PropTypes.number.isRequired,
    couponDiscount: PropTypes.number,
    couponCode: PropTypes.string,
  }).isRequired,
  applyCoupon: PropTypes.func,
  hasProducts: PropTypes.bool,
  resetCoupon: PropTypes.func,
};
export default PaymentSummary;
